// bao migrate skip 
import * as ko from "knockout";
import * as $ from "jquery";
import { Loading } from "./../components/loading/loading";
import Bao from "./../services/bao-service";

ko.bindingHandlers.textInputInit = {
    preprocess: function (value, name, addBindingCallback) {
        return "'" + value + "'";
    },
    init: function (element, valueAccessor, allBindings, data, context) {
        var prop = ko.unwrap(valueAccessor()), value = element.value;
        if ((!prop as any) || !ko.isObservable(data[prop])) {
            data[prop] = ko.observable();
        }
        data[prop](value);
        ko.applyBindingsToNode(element, {
            textInput: data[prop]
        }, context);
    }
};
ko.bindingHandlers.saveValue = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var defaults = {
            url: "AutoComplete/SetAutoCompleteValue"
        };
        var options = $.extend({}, defaults, valueAccessor());
        var previousValue;
        var _focused = false;
        $(element).blur(function (e) {
            if (_focused) {
                _focused = false;
                var value: string = $(element).val() as string;
                if (value.trim() != "" && value != previousValue) {
                    previousValue = value;
                    Bao.post(options.url, JSON.stringify(ko.toJS({
                        key: options.key,
                        text: value
                    })));
                }
            }
        });
        $(element).bind("focus", function () {
            previousValue = $(element).val();
            _focused = true;
        });
    }
};
ko.bindingHandlers.block2 = {
    init: function (element, valueAccessor) {
        var $blocker = $("<div class=\"blockLoading block-partial\"><span></span><img src=\"" + Bao.ContentVersioned("Images/loading3.gif") + "\" alt=\"loading\" /></div>");
        $blocker.hide();
        $(element).css("position", "relative");
        $(element).addClass("loading-container").append($blocker);
        var subscriptions = [];
        if (ko.isObservable(valueAccessor())) {
            subscriptions.push(valueAccessor().subscribe(function (newValue) {
                if (newValue === false) {
                    setTimeout(function () {
                        if (newValue === false) {
                            $blocker.hide();
                        }
                    }, 50);
                }
                else {
                    $blocker.show();
                }
            }));
        }
        if (ko.unwrap(valueAccessor()) === true) {
            $blocker.show();
        }
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if (ko.isObservable(valueAccessor())) {
                valueAccessor()(false);
            }
            for (var i = 0; i < subscriptions.length; i++) {
                subscriptions[i].dispose();
            }
            $blocker.remove();
            $(element).removeClass("loading-container");
        });
    }
};
ko.bindingHandlers.block = {
    init: function (element, valueAccessor) {
        Loading.register(valueAccessor());
        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            if (ko.isObservable(valueAccessor())) {
                valueAccessor()(false);
                Loading.unregister(valueAccessor());
            }
        });
    }
};
ko.bindingHandlers.cloak = {
    init: function (element) {
        setTimeout(function () {
            //$(element).show();
            $(element).removeClass("cloak");
        }, 10);
    }
};
ko.bindingHandlers.enter = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var dependency = ko.utils.unwrapObservable(valueAccessor());
        if (dependency != null && typeof dependency === "function") {
            $(element).keypress(function (event) {
                var key;
                if (window.event) {
                    key = window.event["keyCode"];
                }
                else {
                    key = event.which;
                }
                if (key == 13) {
                    dependency.apply(viewModel, arguments);
                    return false;
                }
                return true;
            });
        }
    }
};
ko.bindingHandlers.focus = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var fnName = valueAccessor();
        if (fnName != null && typeof fnName === "string" && viewModel.hasOwnProperty(fnName) == true) {
            var tempFn = viewModel[fnName];
            var focusFn = function (args) {
                $(element).focus();
                if (tempFn != null && typeof tempFn === "function") {
                    tempFn.apply(this, arguments);
                }
            };
            viewModel[fnName] = focusFn;
        }
    }
};
ko.virtualElements.allowedBindings.module = true;
ko.bindingHandlers.module = {
    init: function (element, valueAccessor) {
        var loading = ko.observable(true);
        ko.applyBindingsToNode(element, {
            block: loading
        });
        var moduleName = ko.utils.unwrapObservable(valueAccessor());
        var loaded = function (vm) {
            $(element).show();
            if (vm != null && typeof vm.loaded == "function") {
                vm.loaded();
            }
            else if (vm != null && typeof vm.Loaded == "function") {
                vm.Loaded();
            }
        };
        var initFn = function (module) {
            var moduleInstance;
            var _creator = module;
            if (module != null && module._module != undefined) {
                _creator = module._module;
            }
            if (typeof _creator == "function") {
                moduleInstance = new _creator();
            }
            else {
                moduleInstance = _creator;
            }
            moduleInstance.init().then(function () {
                ko.applyBindingsToDescendants(moduleInstance, element);
                loaded(moduleInstance);
                loading(false);
            });
        };
        if (typeof moduleName === "string") {
            window.baorequire([moduleName], initFn);
        }
        else if (typeof moduleName === "object") {
            initFn(moduleName);
        }
        return {
            controlsDescendantBindings: true
        };
    }
};
ko.bindingHandlers.readonly = {
    update: function (element, valueAccessor) {
        var value = ko.utils.unwrapObservable(valueAccessor());
        if (value) {
            element.setAttribute("readOnly", true);
        }
        else {
            element.removeAttribute("readOnly");
        }
    }
};
ko.virtualElements.allowedBindings.viewmodel = true;
ko.bindingHandlers.viewmodel = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        //fix for bootstrap problem (row > row problem)
        if ($(element).hasClass("row") && $(element).children(".row").length > 0) {
            $(element).removeClass("row");
        }

        var loading = ko.observable(true);
        ko.applyBindingsToNode(element, {
            block: loading
        });
        var viewModelObject = ko.utils.unwrapObservable(valueAccessor());
        var viewModelName = "";
        var contextDef = $.Deferred();
        var params;
        if (typeof viewModelObject === "string") {
            viewModelName = viewModelObject;
        }
        else if (typeof viewModelObject == "object" && viewModelObject != null) {
            viewModelName = ko.utils.unwrapObservable(viewModelObject.name);
            params = viewModelObject.params;
            if (ko.isObservable(params)) {
                params = params();
            }
        }
        var loaded = function (vm) {
            $(element).show();
            if (vm != null && typeof vm.loaded == "function") {
                vm.loaded();
            }
            else if (vm != null && typeof vm.Loaded == "function") {
                vm.Loaded();
            }
            loading(false);
        };
        if (viewModelObject != null && typeof viewModelObject == "object" && viewModelObject.context != null && viewModel != null && viewModel.Context != undefined && ko.isObservable(viewModel.Context)) {
            Bao.post("Bao/LoadMenu", JSON.stringify({
                formName: ko.toJS(viewModelObject.context),
                color: "",
                applicationId: viewModelObject.applicationId
            }), function (result) {
                var koContext = ko.map.fromJS(result);
                viewModel.Context(koContext);
                contextDef.resolve(koContext);
            });
        }
        else {
            contextDef.resolve(null);
        }
        window.baorequire([viewModelName], function (vm) {
            var viewModelInstance;
            var _creator = vm;
            if (vm != null && vm._module != undefined) {
                _creator = vm._module;
            }
            if (typeof _creator == "function") {
                viewModelInstance = ko.construct(_creator, params);
            }
            else {
                viewModelInstance = _creator;
            }
            contextDef.then(function () {
                if (typeof viewModelInstance.init == "function") {
                    $.when(viewModelInstance.init()).then(function () {
                        ko.applyBindingsToDescendants(viewModelInstance, element);
                        loaded(viewModelInstance);
                    });
                }
                else if (typeof viewModelInstance.Init == "function") {
                    $.when(viewModelInstance.Init()).then(function () {
                        ko.applyBindingsToDescendants(viewModelInstance, element);
                        loaded(viewModelInstance);
                    });
                }
                else {
                    ko.applyBindingsToDescendants(viewModelInstance, element);
                    loaded(viewModelInstance);
                }
                if (viewModel != null && viewModel.ViewModel != null && ko.isObservable(viewModel.ViewModel)) {
                    viewModel.ViewModel(viewModelInstance);
                    loading(false);
                }
            });
        });
        return {
            controlsDescendantBindings: true
        };
    }
};
ko.bindingHandlers.context = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var settings = ko.utils.unwrapObservable(valueAccessor());
        var formName;
        var applicationId = null;
        if (typeof settings === "string") {
            formName = settings;
        }
        else {
            formName = settings.formName;
            applicationId = settings.applicationId;
        }
        if (typeof formName == "string" && viewModel != null && viewModel.Context != undefined && ko.isObservable(viewModel.Context)) {
            Bao.post("Bao/LoadMenu", JSON.stringify({
                formName: formName,
                color: "",
                applicationId: applicationId
            }), function (result) {
                var koContext = ko.map.fromJS(result);
                viewModel.Context(koContext);
            });
        }
    }
};
ko.bindingHandlers.display = {
    update: function (element, valueAccessor) {
        var bool = ko.utils.unwrapObservable(valueAccessor());
        if (bool) {
            $(element).show();
        }
        else {
            $(element).hide();
        }
    }
};
ko.bindingHandlers.tabTitle = {
    update: function (elem, valueAccessor, allBindings, viewModel) {
        if (viewModel != null && viewModel.Title != null && ko.isObservable(viewModel.Title)) {
            viewModel.Title(ko.toJS(valueAccessor()));
        }
    }
};
ko.bindingHandlers.triggerBindings = {
    after: ["html"],
    update: function (elem, valueAccessor, allBindings, viewModel, bindingContext) {
        ko.applyBindingsToDescendants(bindingContext, elem);
        return {
            controlsDescendantBindings: true
        };
    }
};
ko.virtualElements.allowedBindings.tabTitle = true;